export default __webpack_public_path__ + "static/media/004-B-internet.0e6ed53b.svg";